import { product } from '@/js/sections/product';
import { related } from '@/js/sections/related';
import { compatibleDevices } from '@/js/sections/compatible-devices';
import { initRecentlyViewed } from '@/js/sections/recently-viewed';
import { features } from '@/js/sections/features';
import { manual } from '@/js/sections/manual';
import { packageSlider } from '@/js/sections/package';
import '@/js/sections/buy-bar.js';
import { initProductPurchase } from '@/js/sections/product-purchase';
import '@/js/sections/text-popup.js';
import '@/js/sections/stickSeal-video-popup.js';
import '@/js/sections/device-specs.js';
import '@/js/sections/reviews.js';
import '@/js/sections/compare.js';
import { initTestDriveSlider } from '@/js/sections/test-drive';
import { initUpgradePlusSlider } from '@/js/sections/upgrade-plus';

document.addEventListener('DOMContentLoaded', () => {
  product();
  related();
  compatibleDevices();
  initRecentlyViewed();
  features();
  manual();
  packageSlider();
  initProductPurchase();
  initTestDriveSlider();
  initUpgradePlusSlider();
});
